<template>

<div class="key">

    <div class="key-item" v-for="(item, index) in data" :key="index">

        <div class="key-item-color" :style="{ backgroundColor: item.color }" />

        <div class="key-item-text">{{ item.label }}</div>

    </div>

</div>

</template>

<script>

export default {

	props: ['data']

}

</script>

<style scoped>

.key {
    display: flex;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
}

.key-item {
    display: flex;
    padding: 0px 10px;
    align-items: center;
}

.key-item-color {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    margin-right: 10px;
}

.is-mobile .key-item-color {
    height: 16px;
    width: 16px;
    margin-right: 4px;
}

.key-item-text {
    font-size: 14px;
    color: #333;
    line-height: 24px;
    font-weight: 400;
}

.is-mobile .key-item-text {
    font-size: 12px;
    line-height: 12px;
}

</style>